import User from './User';

export class IssuerUser extends User {
  static get entity() {
    return 'issuerUsers';
  }

  static get fk() {
    return 'issuer';
  }

  static fields() {
    return {
      ...User.fields
    };
  }

  static apiConfig = {
    actions: {
      ...User.apiConfig?.actions
    }
  };
}

export default IssuerUser;
